var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative",attrs:{"id":"app","data-test":"main-screen"}},[(_setup.loading)?_c(_setup.LoadingSpinner):(_setup.maintenanceEnabled)?_c(_setup.MaintenanceScreen,{staticClass:"h-full flex items-center justify-center"}):_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }